<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          flat
          color="white"
        >
          <v-btn
            outlined
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
          >
            Hoje
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                outlined
                color="grey darken-2"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 Dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :now="today"
          :type="type"
          locale="pt-BR"
          :short-intervals="false"
          first-interval="6"
          interval-count="18"
          interval-minutes="60"
          @click:more="viewDay"
          @click:event="showEvent"
          @click:date="viewDay"
          @change="updateRange"
        />
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            max-width="300"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title>Confirmar Agendamento ?</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <p><span>Data Início: <strong>{{ selectedEvent.start }}</strong></span></p>
              <p><span>Data Fim: <strong>{{ selectedEvent.end }}</strong></span></p>
              <p><span>Carga Horária: <strong>{{ selectedEvent.time_aula }}</strong></span></p>
              <p><span>Categoria: <strong>{{ selectedEvent.category }}</strong></span></p>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <div class="text-center">
                <v-btn
                  outlined
                  class="mr-10 ml-1"
                  color="red"
                  @click="selectedOpen = false"
                >
                  <v-icon>mdi-calendar-remove</v-icon>Não
                </v-btn>
                <v-btn
                  outlined
                  class="ml-10 mr-1"
                  color="green"
                  @click="()=>confirmAgendamento(selectedEvent)"
                >
                  <v-icon>mdi-calendar-check</v-icon>Sim
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { format, parseISO } from 'date-fns';
import Api from '../../service/Api';
import instrutorApi from './../../ws/instrutor';
import planoAulaApi from './../../ws/planoAula';

  export default {
    data: () => ({
      focus: '',
      today:format(new Date(), 'yyyy-MM-dd'),
      type: '4day',
      typeToLabel: {
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        '4day': '4 Dias',
      },
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
    }),
    computed: {
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }

        const startMonth = this.monthFormatter(start)
        // const endMonth = this.monthFormatter(end)
        // const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        // const endYear = end.year
        // const suffixYear = startYear === endYear ? '' : endYear

        // const startDay = start.day + this.nth(start.day)
        const startDay = start.day;
        // const endDay = end.day + this.nth(end.day)
        const endDay = end.day;

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
          case '4day':
            return `${startDay}-${endDay} ${startMonth}  ${startYear}`
          case 'day':
            return `${startDay} ${startMonth}  ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    async mounted () {
      this.$refs.calendar.checkChange()
    },
    methods: {
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
       getEventColor (event) {
        const color = event.avaible ? 'green':'red';
        return color
      },
      setToday () {
        this.focus = this.today
        this.type = 'day';
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      async confirmAgendamento(aulaEvent){
        const aluno = await this.$store.getters.getAluno;
        const aula = {
            categoria: aulaEvent.category,
            alunoCPF: aluno.cpf,
            aulas: [
              {
                dataHora: format(parseISO(aulaEvent.start), `yyyy-MM-dd'T'HH:mm:ss`),
                placaVeiculo: aulaEvent.veiculo.placa,
                instrutorCPF: this.$route.params.cpf,
                modeloID: 4,
                cargaHoraria: aulaEvent.time_aula <=50 ? "1" :"2"
              }
            ]
        };
        try{
          await planoAulaApi.newplanoAula(aula);
          this.events = this.events.map( even => {
            if(even.start == aulaEvent.start){
              even.avaible = false;
            }
            return even;
          });

          this.selectedOpen = false;
        }catch(err) {
          this.selectedOpen = false;
          const {response } = err;
          const errorResponse = response.data.error.map(erro => erro.error);
          alert(`${response.status} - ${errorResponse.join('')}`);
        }
      },
      showEvent ({ nativeEvent, event }) {
        if(event.avaible){
          //this.selectedElement = nativeEvent.target
          this.selectedEvent = event
          this.selectedOpen = true;
        }else{
          this.selectedOpen = false;
          this.selectedElement = false
        }
        nativeEvent.stopPropagation()

      },
      async updateRange ({ start, end }) {
         const response = await instrutorApi.findByCpf(this.$route.params.cpf);
         this.instrutor = response.data;
        Api.get(`instrutores/${this.instrutor.cpf}/agenda/servico/${this.$route.params.idServico}`,{
            params:{
              dateStart: start.date,
              dateEnd: end.date
            }
          }).then( response =>{
            const { agenda, instrutor} = response.data;
            this.instrutor = instrutor;
            this.events= agenda;
            this.start = start
            this.end = end
          });

      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      formatDate (a, withTime) {
        return withTime
          ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
      },
      formatdatePtBR(date){
        const dateFormated = format(new Date(date), 'dd/MM/yyy H:m');
        return dateFormated;
      },
    },
  }
</script>
